import * as THREE from "three";

// Window glass writes this stencil value; the sky and everything outdoors draw only where it is set.
const SKY_STENCIL_REF = 1;

let maskMaterial = null;

/** Stencil-only twin of a pane, drawn first (opaque pass, lowest renderOrder) so the sky shows through it. */
export function createSkyMask(pane) {
  maskMaterial ??= new THREE.MeshBasicMaterial({
    colorWrite: false,
    depthWrite: false,
    side: THREE.DoubleSide,
    stencilWrite: true,
    stencilRef: SKY_STENCIL_REF,
    stencilFunc: THREE.AlwaysStencilFunc,
    stencilZPass: THREE.ReplaceStencilOp,
  });
  const mask = new THREE.Mesh(pane.geometry, maskMaterial);
  mask.position.copy(pane.position);
  mask.quaternion.copy(pane.quaternion);
  mask.renderOrder = -1000;
  mask.raycast = () => {};
  return mask;
}

/** three runs the stencil test only while `stencilWrite` is on; the default Keep ops leave the buffer alone. */
export function setSkyStencilTest(material, masked) {
  material.stencilWrite = masked;
  material.stencilRef = SKY_STENCIL_REF;
  material.stencilFunc = THREE.EqualStencilFunc;
}
